import $ from 'jquery'
import {animTxtWave} from "../elements/txt_waves";

if ($('.entry-header').length) {
    $('.sub_title').addClass('animate__animated  animate__slideInUp')
    animTxtWave($(".sub_title"))
}
